// Import dependencies
import { builderFetch } from '@automator/builder/utils';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';
import { confirm } from '@automator/shared/utils/confirm';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { getLoopFilter } from '@automator/builder/services/item/loop';

/**
 * Deletes a loop filter
 *
 * @param {Number} loopID The loop ID (post ID)
 * @param {Number} loopFilterID The loop filter ID (post ID)
 * @return {Promise} The apiFetch promise
 */
const deleteLoopFilter = async ( loopID, loopFilterID ) => {
	// Event name
	const eventName = 'uap/builder/core/item/loop/delete-loop-filter';

	// Get the loop filter
	const loopFilter = getLoopFilter( loopID, loopFilterID );

	// If the item is not define, stop here
	if ( isEmpty( loopFilter ) ) {
		throw new Error( `deleteLoopFilter: The filter ${ loopFilterID } doesn't exist` );
	}

	await confirm( {
		content: escapeHTML( __( 'This action cannot be undone.', 'uncanny-automator' ) ),
		confirmButtonLabel: escapeHTML( __( 'Delete loop filter', 'uncanny-automator' ) )
	} );

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'delete_filter',
			// eslint-disable-next-line camelcase
			loop_id: loopID,
			// eslint-disable-next-line camelcase
			loop_filter_id: loopFilterID
		},
		snackbar: {
			loading: escapeHTML( __( 'Deleting loop filter', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Loop filter deleted successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					loopID: loopID,
					loopFilterID: loopFilterID
				}
			} ) );
		}

		return response;
	} );
}

export default deleteLoopFilter;
